// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_title__FA8TO {
  margin: 8px 0;
}

.styles_esignChartsContainer__LgjOE {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -8px;
}

.styles_esignChartsItem__zPsUY {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding: 0 8px;
  margin: 8px 0;
}

.styles_esignCard__VKTk4 {
  overflow: hidden;
}

.styles_esignCard__VKTk4 h3 {
  padding: 8px 16px;
  font-weight: 700 !important;
}

.styles_esignCardContent__CFyIA {
  position: relative;
  height: 350px;
}

.styles_esignSmallCard__ocbF1 {
  width: 33%;
  min-width: 300px;
  flex-grow: 1;
}

.styles_esignMediumCard__OJPLU {
  width: 50%;
  min-width: 300px;
  flex-grow: 1;
}

.styles_esignBigCard__ntwpM {
  width: 66%;
  min-width: 300px;
  flex-grow: 1;
}

.styles_esignTableBlock__iB9BJ {
  padding: 8px 8px 16px;
  overflow-x: auto;
}

.styles_esignTableBlock__iB9BJ::-webkit-scrollbar {
  width: 3px;
  height: 3px;
  border-radius: 3px;
}

.styles_esignTableBlock__iB9BJ::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: rgb(0 0 0 / 80%);
}

.styles_esignTableBlock__iB9BJ::-webkit-scrollbar-track {
  border-radius: 3px;
  background-color: rgb(0 0 0 / 10%);
}

.styles_esignStatusBlock__Ijhp9 {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.styles_esignStatusCircle__0c8za {
  display: flex;
  width: 175px;
  height: 175px;
  align-items: center;
  justify-content: center;
  border: var(--color-light-red) 4px solid;
  border-radius: 50%;
  animation: styles_fadeIn__k4To6 1s ease 0s 1 normal;
  background-color: var(--color-pop-red);
  color: var(--color-dark-red);
  text-align: center;
  text-transform: capitalize;
  transition: 0.3s;
}

.styles_esignOkStatusCircle__veqDq {
  border: var(--color-light-green) 4px solid;
  background-color: var(--color-pop-green);
  color: var(--color-dark-green);
}

.styles_esignStatusCircle__0c8za:hover {
  border-width: 8px;
  opacity: 0.8;
}

.styles_esignUserCountBlock__sK3rM {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  animation: styles_fadeIn__k4To6 1s ease 0s 1 normal;
  font-size: 56px;
  font-weight: 700;
}

.styles_esignCustomCardTitle__qSz-H {
  padding: 8px 16px;
  margin: 0;
  font-size: 20px;
  line-height: 1.35;
}

.styles_esignCustomCardSubTitle__7gIJi {
  font-size: 12px;
  font-weight: 500;
}

@keyframes styles_fadeIn__k4To6 {
  0% {
    opacity: 0;
    transform: scale(0.6);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DashboardCharts/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,kBAAkB;EAClB,mDAAqC;EACrC,sCAAsC;EACtC,4BAA4B;EAC5B,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mDAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":[".title {\n  margin: 8px 0;\n}\n\n.esignChartsContainer {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 -8px;\n}\n\n.esignChartsItem {\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0 8px;\n  margin: 8px 0;\n}\n\n.esignCard {\n  overflow: hidden;\n}\n\n.esignCard h3 {\n  padding: 8px 16px;\n  font-weight: 700 !important;\n}\n\n.esignCardContent {\n  position: relative;\n  height: 350px;\n}\n\n.esignSmallCard {\n  width: 33%;\n  min-width: 300px;\n  flex-grow: 1;\n}\n\n.esignMediumCard {\n  width: 50%;\n  min-width: 300px;\n  flex-grow: 1;\n}\n\n.esignBigCard {\n  width: 66%;\n  min-width: 300px;\n  flex-grow: 1;\n}\n\n.esignTableBlock {\n  padding: 8px 8px 16px;\n  overflow-x: auto;\n}\n\n.esignTableBlock::-webkit-scrollbar {\n  width: 3px;\n  height: 3px;\n  border-radius: 3px;\n}\n\n.esignTableBlock::-webkit-scrollbar-thumb {\n  border-radius: 3px;\n  background-color: rgb(0 0 0 / 80%);\n}\n\n.esignTableBlock::-webkit-scrollbar-track {\n  border-radius: 3px;\n  background-color: rgb(0 0 0 / 10%);\n}\n\n.esignStatusBlock {\n  display: flex;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n}\n\n.esignStatusCircle {\n  display: flex;\n  width: 175px;\n  height: 175px;\n  align-items: center;\n  justify-content: center;\n  border: var(--color-light-red) 4px solid;\n  border-radius: 50%;\n  animation: fadeIn 1s ease 0s 1 normal;\n  background-color: var(--color-pop-red);\n  color: var(--color-dark-red);\n  text-align: center;\n  text-transform: capitalize;\n  transition: 0.3s;\n}\n\n.esignOkStatusCircle {\n  border: var(--color-light-green) 4px solid;\n  background-color: var(--color-pop-green);\n  color: var(--color-dark-green);\n}\n\n.esignStatusCircle:hover {\n  border-width: 8px;\n  opacity: 0.8;\n}\n\n.esignUserCountBlock {\n  display: flex;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  animation: fadeIn 1s ease 0s 1 normal;\n  font-size: 56px;\n  font-weight: 700;\n}\n\n.esignCustomCardTitle {\n  padding: 8px 16px;\n  margin: 0;\n  font-size: 20px;\n  line-height: 1.35;\n}\n\n.esignCustomCardSubTitle {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.6);\n  }\n\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `styles_title__FA8TO`,
	"esignChartsContainer": `styles_esignChartsContainer__LgjOE`,
	"esignChartsItem": `styles_esignChartsItem__zPsUY`,
	"esignCard": `styles_esignCard__VKTk4`,
	"esignCardContent": `styles_esignCardContent__CFyIA`,
	"esignSmallCard": `styles_esignSmallCard__ocbF1`,
	"esignMediumCard": `styles_esignMediumCard__OJPLU`,
	"esignBigCard": `styles_esignBigCard__ntwpM`,
	"esignTableBlock": `styles_esignTableBlock__iB9BJ`,
	"esignStatusBlock": `styles_esignStatusBlock__Ijhp9`,
	"esignStatusCircle": `styles_esignStatusCircle__0c8za`,
	"fadeIn": `styles_fadeIn__k4To6`,
	"esignOkStatusCircle": `styles_esignOkStatusCircle__veqDq`,
	"esignUserCountBlock": `styles_esignUserCountBlock__sK3rM`,
	"esignCustomCardTitle": `styles_esignCustomCardTitle__qSz-H`,
	"esignCustomCardSubTitle": `styles_esignCustomCardSubTitle__7gIJi`
};
export default ___CSS_LOADER_EXPORT___;
